import { sortBy } from 'lodash'

import { TickRuleGroupDto } from '@/gen/publicApi'

import { Input } from '@/components/input'
import { Label } from '@/components/label'

interface Props {
    type: 'unit' | 'price'
    ruleGroups: TickRuleGroupDto[]
}

const headings = {
    unit: 'Unit Tick Rules',
    price: 'Price Tick Rules',
}

export default function RuleGroups({ type, ruleGroups }: Props) {
    return (
        <>
            <h3 className="mt-4">{headings[type]}</h3>
            {ruleGroups.map(ruleGroup => {
                const ticks = sortBy(ruleGroup.tickRules, rule => parseFloat(rule.startPrice))
                return (
                    <div key={ruleGroup.name}>
                        <h5 className="mt-3">{ruleGroup.name}</h5>

                        {ticks.map(tick => (
                            <div className="flex space-x-3 pt-2" key={tick.startPrice}>
                                <div className="w-1/3">
                                    <Label>Start Price</Label>
                                    <Input value={tick.startPrice} disabled />
                                </div>
                                <div className="w-1/3">
                                    <Label>End Price</Label>
                                    <Input value={tick.endPrice || '-'} disabled />
                                </div>
                                <div className="w-1/3">
                                    <Label>Tick</Label>
                                    <Input value={tick.tick} disabled />
                                </div>
                            </div>
                        ))}
                    </div>
                )
            })}
        </>
    )
}
